// Product Card Variant Selector with Add to Cart
document.addEventListener('DOMContentLoaded', function() {
  // Set overlay heights to match figure elements
  function updateOverlayHeights() {
    document.querySelectorAll('.product-card-variant-overlay').forEach(overlay => {
      const productCard = overlay.closest('.product-card');
      const figure = productCard ? productCard.querySelector('.product-card--featured-image') : null;

      if (figure) {
        const figureHeight = figure.offsetHeight;
        overlay.style.height = `${figureHeight}px`;
      }
    });
  }

  // Update on load and resize
  updateOverlayHeights();
  window.addEventListener('resize', updateOverlayHeights);

  // Update after images load
  window.addEventListener('load', updateOverlayHeights);

  const variantToggles = document.querySelectorAll('.product-card-variant-toggle');

  // Toggle dropdown
  variantToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const productId = this.dataset.productId;
      const variantSelector = document.querySelector(`.product-card-variant-selector[data-product-id="${productId}"]`);

      // Close all other open selectors
      document.querySelectorAll('.product-card-variant-selector.active').forEach(selector => {
        if (selector !== variantSelector) {
          selector.classList.remove('active');
          const otherToggle = document.querySelector(`.product-card-variant-toggle[data-product-id="${selector.dataset.productId}"]`);
          if (otherToggle) {
            otherToggle.classList.remove('active');
          }
        }
      });

      // Toggle current selector
      const isActive = variantSelector.classList.toggle('active');
      this.classList.toggle('active', isActive);
    });
  });

  // Handle variant selection and add to cart
  document.querySelectorAll('.product-card-variant-option').forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Don't proceed if unavailable
      if (this.dataset.variantAvailable === 'false' || this.disabled) {
        return;
      }

      const variantId = this.dataset.variantId;
      const selector = this.closest('.product-card-variant-selector');
      const productTitle = selector.dataset.productTitle;

      // Show loading state
      this.classList.add('loading');

      try {
        // Add to cart
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const data = await response.json();
        console.log('Added to cart:', data);

        // Refresh cart drawer using centralized function
        if (typeof window.refreshCart === 'function') {
          await window.refreshCart();
        } else {
          console.warn('window.refreshCart not available, falling back to local method');
          await refreshCartDrawer();
        }

        // Close the selector
        selector.classList.remove('active');
        const toggle = document.querySelector(`.product-card-variant-toggle[data-product-id="${selector.dataset.productId}"]`);
        if (toggle) {
          toggle.classList.remove('active');
        }

        // Show success feedback (optional - you can customize this)
        showAddedToCartFeedback(this);

      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Sorry, there was an error adding this item to your cart. Please try again.');
      } finally {
        // Remove loading state
        this.classList.remove('loading');
      }
    });
  });

  // Close selector when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product-card--featured-image')) {
      document.querySelectorAll('.product-card-variant-selector.active').forEach(selector => {
        selector.classList.remove('active');
      });
      document.querySelectorAll('.product-card-variant-toggle.active').forEach(toggle => {
        toggle.classList.remove('active');
      });
    }
  });

  // Prevent clicks inside selector from closing it
  document.querySelectorAll('.product-card-variant-selector').forEach(selector => {
    selector.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
});

/**
 * Refresh cart drawer after adding item (Legacy fallback)
 * NOTE: Use window.refreshCart() from cart-refresh.js instead for proper updates
 */
async function refreshCartDrawer() {
  console.log('Refreshing cart drawer (legacy fallback)...');

  try {
    // Fetch updated cart
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartResponse.json();
    console.log('Cart data:', cart);

    // Update cart count
    const cartCount = cart.item_count;
    document.querySelectorAll('.thb-item-count').forEach(el => {
      el.textContent = cartCount;
      if (cartCount > 0) {
        el.style.display = '';
      }
    });

    // Fetch and update cart drawer section
    const sections = 'cart-drawer,cart-bubble';
    const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sections}`);
    const sectionsData = await sectionsResponse.json();

    // Update cart drawer content
    if (sectionsData['cart-drawer']) {
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
        const newDrawer = doc.querySelector('.cart-drawer');
        const currentDrawer = cartDrawer.querySelector('.cart-drawer');

        if (newDrawer && currentDrawer) {
          console.log('Replacing cart drawer content');
          currentDrawer.replaceWith(newDrawer);
        }
      }
    }

    // Update cart bubble
    if (sectionsData['cart-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsData['cart-bubble'], 'text/html');
      const newBubble = doc.querySelector('.thb-item-count');
      const currentBubbles = document.querySelectorAll('.thb-item-count');

      if (newBubble) {
        currentBubbles.forEach(bubble => {
          if (bubble && !bubble.closest('#Cart-Drawer')) {
            bubble.replaceWith(newBubble.cloneNode(true));
          }
        });
      }
    }

    // Dispatch events for other scripts
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

    // Open cart drawer if it's not already open
    const cartDrawerElement = document.getElementById('Cart-Drawer');
    if (cartDrawerElement && !cartDrawerElement.classList.contains('active')) {
      const sidePanelTrigger = document.querySelector('[data-side-panel="Cart-Drawer"]');
      if (sidePanelTrigger) {
        sidePanelTrigger.click();
      }
    }

    console.log('Cart drawer refresh complete');
  } catch (error) {
    console.error('Error refreshing cart drawer:', error);
  }
}

// Show brief success feedback
function showAddedToCartFeedback(button) {
  const originalContent = button.innerHTML;
  button.innerHTML = '<span style="color: var(--color-accent);">✓ Added</span>';

  setTimeout(() => {
    button.innerHTML = originalContent;
  }, 1500);
}
